import React from 'react';
import compose from 'lodash/fp/compose';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';

import AuthorizationProvider from 'components/shared/Authorization/AuthorizationProvider';
import withErrorPageBoundary from 'utils/withErrorPageBoundary';
import getDisplayName from 'utils/getDisplayName';
import { isMobileDevice } from 'utils/browserCheck';

export default function Page({ children }) {
  return (
    <AuthorizationProvider>
      <DndProvider backend={isMobileDevice() ? TouchBackend : HTML5Backend}>
        {children}
      </DndProvider>
    </AuthorizationProvider>
  );
}

export function withPage(PageComponent, componentName) {
  const ComposedPageComponent = compose(withErrorPageBoundary)(PageComponent);

  const PageComponentWrapper = props => (
    <Page>
      <ComposedPageComponent {...props} />
    </Page>
  );
  PageComponentWrapper.displayName = `Page(${
    componentName || getDisplayName(PageComponent)
  })`;

  return props => <PageComponentWrapper {...props} />;
}
